"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
import {
  AccountSessionMixins
} from "@/service/account-session";
export class TransferVdForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.dest_phone = "";
    this.security_code = "";
    this.move_tabs = false;
    this.move_totps = false;
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("transfervddialog.account_cannot_be_empty"),
    trigger: "blur"
  }])
], TransferVdForm.prototype, "dest_phone", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("transfervddialog.security_opcode_cannot_be_empty"),
    trigger: "blur"
  }])
], TransferVdForm.prototype, "security_code", 2);
let TransferVdDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.rows = [];
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.controller = new TransferVdForm();
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  toAccount() {
    const { href } = this.$router.resolve({
      path: "/account?tab=OrgSetting"
    });
    window.open(href, "_blank");
  }
  toUser() {
    window.open("https://www.kuajingvs.com/help", "_blank");
  }
  submit() {
    return __async(this, null, function* () {
      try {
        let ids = [];
        for (const item of this.rows) {
          ids.push(item.oldId);
        }
        yield API.post(`api://base.auth/api/v8/virtual_desktops/change_owner`, {
          "dest_phone": this.controller.dest_phone,
          "security_code": this.controller.security_code,
          "vd_guid": ids[0],
          "transfer_bookmark": this.controller.move_tabs,
          "transfer_two_step_valid": this.controller.move_totps
        });
        this.$message.success(this.$t("transfervddialog.transfer_success"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          if (error.response.data.errors.datas[0].code === "transfer_over_times_error") {
            this._transfer_error_dialog.show();
          }
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  closeErrorDialog() {
    this._transfer_error_dialog.hide();
  }
  open(rows) {
    this.rows = rows;
    this.controller = new TransferVdForm();
    this.controller.security_code = "";
    this.controller.dest_phone = "";
    this.controller.move_tabs = false;
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
};
__decorateClass([
  Ref("transfer_error_dialog")
], TransferVdDialog.prototype, "_transfer_error_dialog", 2);
TransferVdDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], TransferVdDialog);
export {
  TransferVdDialog as default
};
